import React, {Component} from "react";
import {connect} from "react-redux";
import Table from "../../components/Table";
import DistributionItem from "./DistributionItem";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {fromJS, List} from "immutable";
import {graphql} from "react-apollo";
import {DISTRIBUTION, ON_DISTRIBUTION_UPDATED} from "../../queries/shipping";
import "./DistributionList.css";

class DistributionList extends Component {

  UNSAFE_componentWillMount() {
    this.props.subscribeToUpdates(this.props, {})
  }

  render() {
    let {loading, error, distribution} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />
    let tableHeader = List([
      "Code",
      "Name",
      "Warehouse",
      "System",
      "Shop"
    ])          
    return (
      <Table 
        data={fromJS(distribution)} 
        renderer={DistributionItem} 
        onItemClick={this.handleItemClick.bind(this)}
        tableHeader={tableHeader}
        extraClassName="DistributionList"
        itemKey="code"
        mode="table"
        selected={this.props.selectedId}
        />
    )
  }

  handleItemClick(itemData, e, field = "") {
    this.props.onSelectionChange(itemData);
  }  
}


const mapDispatchToProps = dispatch => ({
  subscribeToUpdates: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_DISTRIBUTION_UPDATED,
      updateQuery: (prev, { subscriptionData }) => {
        props.data.refetch();
        return prev;
      }
    })
  }
})

const withSubscription = connect(null, mapDispatchToProps);

const withQuery = graphql(DISTRIBUTION, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      kind: props.kind
    }
  })
})

export default withQuery(withSubscription(DistributionList));
